import googleDefinition from '../utils/GoogleDefinition.json';
import _ from 'lodash';

export const excelSheets = [
  {
    original_name: 'Menu',
    name: 'google.sheet.menu',
    name_eng: 'Menu',
    ad_type: 'PRESET',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'CampaignReport',
    name: 'google.sheet.campaignReport',
    name_eng: 'CampaignReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: 'CampaignChart'
  },
  {
    original_name: 'SearchAdGroupReport',
    name: 'google.sheet.searchAdGroupReport',
    name_eng: 'SearchAdGroupReport',
    ad_type: 'SEARCH',
    selected: true,
    graphic_name: 'SearchAdGroupChart'
  },
  {
    original_name: 'KeywordReport',
    name: 'google.sheet.keywordReport',
    name_eng: 'KeywordReport',
    ad_type: 'SEARCH',
    selected: true,
    graphic_name: 'KeywordChart'
  },
  {
    original_name: 'SearchTermReport',
    name: 'google.sheet.searchTermReport',
    name_eng: 'SearchTermReport',
    ad_type: 'SEARCH',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'AdReport',
    name: 'google.sheet.adReport',
    name_eng: 'AdReport',
    ad_type: 'SEARCH',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DisplayAdGroupReport',
    name: 'google.sheet.displayAdGroupReport',
    name_eng: 'DisplayAdGroupReport',
    ad_type: 'DISPLAY',
    selected: true,
    graphic_name: 'DisplayAdGroupChart'
  },
  {
    original_name: 'ImagePerformanceReport',
    name: 'google.sheet.imagePerformanceReport',
    name_eng: 'ImagePerformanceReport',
    ad_type: 'DISPLAY',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'VideoPerformanceReport',
    name: 'google.sheet.videoPerformanceReport',
    name_eng: 'VideoPerformanceReport',
    ad_type: 'VIDEO',
    selected: true,
    graphic_name: 'VideoPerformanceChart'
  },
  {
    original_name: 'VideoAdgroupPerformanceReport',
    name: 'google.sheet.videoAdgroupPerformanceReport',
    name_eng: 'VideoAdgroupPerformanceReport',
    ad_type: 'VIDEO',
    selected: true,
    graphic_name: 'VideoAdgroupPerformanceChart'
  },
  {
    original_name: 'VideoDailyPerformanceReport',
    name: 'google.sheet.videoDailyPerformanceReport',
    name_eng: 'VideoDailyPerformanceReport',
    ad_type: 'VIDEO',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'PlacementReport',
    name: 'google.sheet.placementReport',
    name_eng: 'PlacementReport',
    ad_type: 'DISPLAY_VIDEO',
    selected: true,
    graphic_name: 'PlacementChart'
  },
  {
    original_name: 'CountryReport',
    name: 'google.sheet.countryReport',
    name_eng: 'CountryReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: 'CountryChart'
  },
  {
    original_name: 'LocationReport_Specify',
    name: 'google.sheet.locationReportSpecify',
    name_eng: 'LocationReport(Specify)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'LocationReport_Area',
    name: 'google.sheet.locationReportArea',
    name_eng: 'LocationReport(Area)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'LocationReport_City',
    name: 'google.sheet.locationReportCity',
    name_eng: 'LocationReport(City)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'HourlyReport',
    name: 'google.sheet.hourlyReport',
    name_eng: 'HourlyReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DeviceReport',
    name: 'google.sheet.deviceReport',
    name_eng: 'DeviceReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DeviceReport_Campaign',
    name: 'google.sheet.deviceReportCampaign',
    name_eng: 'DeviceReport(Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'AgeReport',
    name: 'google.sheet.ageReport',
    name_eng: 'AgeReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'GenderReport',
    name: 'google.sheet.genderReport',
    name_eng: 'GenderReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  // {
  //   original_name: 'CustomerSegmentReport',
  //   name: 'google.sheet.customerSegmentReport',
  //   name_eng: 'CustomerSegmentReport',
  //   ad_type: 'ALL',
  //   selected: true,
  //   graphic_name: null
  // },
  {
    original_name: 'LabelReport',
    name: 'google.sheet.labelReport',
    name_eng: 'LabelReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'CountryReport_Campaign',
    name: 'google.sheet.countryReportCampaign',
    name_eng: 'CountryReport (Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'LocationReport_Specify_Campaign',
    name: 'google.sheet.locationReportSpecifyCampaign',
    name_eng: 'LocationReport(Specify-Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'LocationReport_Area_Campaign',
    name: 'google.sheet.locationReportAreaCampaign',
    name_eng: 'LocationReport(Area-Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'LocationReport_City_Campaign',
    name: 'google.sheet.locationReportCityCampaign',
    name_eng: 'LocationReport(City-Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'HourlyReport_Campaign',
    name: 'google.sheet.hourlyReportCampaign',
    name_eng: 'HourlyReport (Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'AdLabelReport_Campaign',
    name: 'google.sheet.adLabelReportCampaign',
    name_eng: 'AdLabelReport (Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DailyReport',
    name: 'google.sheet.dailyReport',
    name_eng: 'DailyReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DailyReport_Campaign',
    name: 'google.sheet.dailyReportCampaign',
    name_eng: 'DailyReport (Campaign)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'DailyReport_Label',
    name: 'google.sheet.dailyReportLabel',
    name_eng: 'DailyReport (Label)',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  },
  {
    original_name: 'MonthlyReport',
    name: 'google.sheet.monthlyReport',
    name_eng: 'MonthlyReport',
    ad_type: 'ALL',
    selected: true,
    graphic_name: null
  }
]

//所有頁籤
const filterExcelSheets = excelSheets.filter((el) => el.selected === true && el.original_name !== 'Menu');
export const presetExcelSheets = filterExcelSheets.map((el) => el.original_name);
const graphicExcelSheets = filterExcelSheets.map((el) => el.graphic_name).filter((item) => item !== null);
export const allExcelSheets = _.concat(presetExcelSheets, graphicExcelSheets);

//影片類頁籤
const filterVideoSheets = excelSheets.filter((el) => el.ad_type === 'VIDEO');
export const presetVideoSheets = filterVideoSheets.map((el) => el.original_name);

//排序所有欄位
const fieldsSort = googleDefinition.sort((a, b) => {
  return a.categoryIndex - b.categoryIndex;
})

//不是維度、非隱藏欄位
const fixFieldsData = fieldsSort.filter((el) => {
  return el.isDimension === false && el.hidden === false;
});

//非轉換欄位
const noConversionsFields = fixFieldsData.filter((el) => {
  return el.categoryId !== "Conversions";
});

//轉換、所有轉換以外欄位
const noAllConversionsFields = noConversionsFields.filter((el) => {
  return el.categoryId !== "All Conversions";
});

//--------------------------------------------------------資料層(回傳格式)-------------------------------------------------

//一般欄位 回傳
export const generalData = noAllConversionsFields.map((edition, index) => {
  return {
    name: edition.name,
    name_en: edition.name_eng,
    name_ja: edition.name_jp,
    expression: edition.googleapi,
    format: edition.format,
    type: edition.type,
    indexNumber: edition.indexNumber,
    sheet: edition.sheet,
  };
});

//所有轉換、轉換欄位sheet預設為[]
export const conversionsData = fieldsSort
  .filter((el) => el.categoryId === "All Conversions" || el.categoryId === "Conversions")
  .filter((el) => el.id !== "conversion") //"轉換動作"欄不顯示
  .map((edition, index) => {
    return {
      name: edition.name,
      name_en: edition.name_eng,
      name_ja: edition.name_jp,
      expression: edition.googleapi,
      format: edition.format,
      type: edition.type,
      indexNumber: edition.indexNumber,
      sheet: edition.sheet,
    }
  })

//轉換欄位sheet加上全部頁籤
export const tickConversionsData = JSON.parse(JSON.stringify(conversionsData))
tickConversionsData[0].sheet = presetExcelSheets;
tickConversionsData[1].sheet = presetExcelSheets;
tickConversionsData[2].sheet = presetExcelSheets;
tickConversionsData[3].sheet = _.concat(['menu'], presetVideoSheets); //瀏覽後轉換預設影片頁籤
tickConversionsData[4].sheet = presetExcelSheets;
tickConversionsData[5].sheet = presetExcelSheets;

//所有轉換欄位sheet加上全部頁籤
export const tickAllConversionsData = JSON.parse(JSON.stringify(conversionsData))
tickAllConversionsData[6].sheet = presetExcelSheets;
tickAllConversionsData[7].sheet = presetExcelSheets;
tickAllConversionsData[8].sheet = presetExcelSheets;

//--------------------------------------------------------顯示層--------------------------------------------------------

//自定義指標欄位
const initializeCustomFields = [
  {
    category: 'custom',
    name: '自定義指標',
    child: []
  }
]

//固定欄位 顯示
const fixedFields = Array.from(
  new Set(fixFieldsData.map((s) => s.categoryName))
).map((lab, index) => {
  return {
    category: fixFieldsData.filter(s => s.categoryName === lab)[0].categoryId,
    name: lab,
    child: fixFieldsData
      .filter((s) => s.categoryName === lab)
      .filter((s) => s.id !== "conversion") //"轉換動作"欄不顯示
      .map((edition) => {
        return {
          name: edition.name,
          name_en: edition.name_eng,
          name_ja: edition.name_jp,
          expression: edition.googleapi,
          format: edition.format,
          type: edition.type,
          indexNumber: edition.indexNumber,
          categoryIndex: edition.categoryIndex,
          sheet: edition.sheet,
        };
      })
  };
});

// export const allFixedFields = initializeCustomFields.concat(fixedFields);
export const allFixedFields = fixedFields;

//信件指標
export const emailTemplateFields = Array.from(
  new Set(fixFieldsData.map((s) => s.categoryName))
).map((lab, index) => {
  return {
    category: fixFieldsData.filter(s => s.categoryName === lab)[0].categoryId,
    name: lab,
    child: fixFieldsData
      .filter((s) => s.categoryName === lab && s.format !== 'STRING' && s.id !== "conversion")
      .map((edition) => {
        return {
          name: edition.name,
          name_en: edition.name_eng,
          name_ja: edition.name_jp,
          expression: edition.googleapi,
          format: edition.format,
          type: edition.type,
          indexNumber: edition.indexNumber,
          categoryIndex: edition.categoryIndex,
          sheet: edition.sheet,
        };
      })
  };
});

//轉換
export const conversionsFields = Array.from(new Set(fieldsSort
  .filter((el) => el.categoryId === "Conversions")
  .map((s) => s.categoryName))).map(
    (lab, index) => {
      return {
        category: `${lab}_${index}`,
        name: lab,
        child: fieldsSort
          .filter((el) => el.categoryId === "Conversions")
          .filter((el) => el.id !== "conversion") //"轉換動作"欄不顯示
          .map((edition) => {
            return {
              name: edition.name,
              name_en: edition.name_eng,
              name_ja: edition.name_jp,
              expression: edition.googleapi,
              format: edition.format,
              type: edition.type,
              indexNumber: edition.indexNumber,
              categoryIndex: edition.categoryIndex,
              sheet: edition.sheet,
            };
          })
      };
    }
  );

//所有轉換
export const allConversionsFields = Array.from(new Set(fieldsSort
  .filter((el) => el.categoryId === "All Conversions")
  .map((s) => s.categoryName))).map(
    (lab, index) => {
      return {
        category: `${lab}_${index}`,
        name: lab,
        child: fieldsSort
          .filter((el) => el.categoryId === "All Conversions")
          .map((edition) => {
            return {
              name: edition.name,
              name_en: edition.name_eng,
              name_ja: edition.name_jp,
              expression: edition.googleapi,
              format: edition.format,
              type: edition.type,
              indexNumber: edition.indexNumber,
              categoryIndex: edition.categoryIndex,
              sheet: edition.sheet,
            };
          })
      };
    }
  );